import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExtensionIcon(props: IconProps) {
    return <Icon {...props} iconKey={"extension"}/>
}
